import { ImgHTMLAttributes } from 'react';
import { flags, FlagIconCode } from './flagIcons';

export interface FlagIconProps extends ImgHTMLAttributes<HTMLImageElement> {
  size?: number;
  code: FlagIconCode | string;
}

export const FlagIcon = ({
  code,
  alt = code,
  size = 24,
  width = size,
  height = size * 0.75,
  ...props
}: FlagIconProps) => {
  const src = flags[code] ?? flags.default;

  if (typeof src !== 'string') return null;

  return <img loading="lazy" {...props} alt={alt} width={width} height={height} src={src} />;
};
